export const COLORS = {
  gray0: '#ffffff',
  gray5: '#fafafa',
  gray10: '#f5f5f5',
  gray20: '#ededed',
  gray30: '#dbdbdb',
  gray40: '#cccccc',
  gray50: '#bdbdbd',
  gray60: '#9e9e9e',
  gray70: '#757575',
  gray80: '#424242',
  gray90: '#292929',
  gray100: '#000000',
  skyblue5: '#effbff',
  skyblue10: '#e5f9ff',
  skyblue20: '#c7effb',
  skyblue30: '#a3e4f8',
  skyblue40: '#6cd5f4',
  skyblue50: '#35c5f0',
  skyblue60: '#09addb',
  skyblue70: '#0f9dc8',
  skyblue80: '#0c80a3',
  skyblue90: '#09647f',
  skyblue100: '#07475a',
  blue5: '#f9fcfe',
  blue10: '#e8f4fc',
  blue20: '#c5e3f8',
  blue30: '#90caf1',
  blue40: '#6db9ed',
  blue50: '#3a9ee0',
  blue60: '#1778ba',
  blue70: '#09609c',
  blue80: '#004e83',
  blue90: '#023d63',
  blue100: '#052c47',
  red5: '#ffeded',
  red10: '#ffd9d9',
  red20: '#ffc5c5',
  red30: '#ffb2b2',
  red40: '#ff9494',
  red50: '#ff7777',
  red60: '#f06060',
  red70: '#db4646',
  red80: '#c73c3c',
  red90: '#a83131',
  red100: '#8a2525',
  slategray5: '#f7f8fa',
  slategray10: '#eaebef',
  slategray20: '#dadce0',
  slategray30: '#c2c8cc',
  slategray40: '#a4acb3',
  slategray50: '#828c94',
  slategray60: '#656e75',
  slategray70: '#525b61',
  slategray80: '#3f474d',
  slategray90: '#2f3438',
  slategray100: '#212529',
} as const;
